$(function () {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang || 'fi';
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    let prefix;
    switch (language) {
        case "is-en":
        case "is":
            prefix = "youpret_iceland";
            break;
        case "ee":
        case "ee-en":
        case "ee-ru":
        case "et":
            prefix = "youpret_estonia";
            break;
        default:
            prefix = "youpret";
    }

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language, "X-Prefix": prefix },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kiitos-yhteys/",
        uri: "/fi/demo/"
    };

    $("#demoForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#demoForm')[0].checkValidity()) {
            $("#demoSendBtn").prop("disabled", true);
            $("#demoSendBtn").css("background-color", "#6c757d");

            let firstName = $("#demoFirstName").val();
            let lastName = $("#demoLastName").val();
            let email = $("#demoEmail").val();
            let organization = $("#demoOrganization").val() || "";

            let solutions = [];
            $("input[name='solution']:checked").each(function () {
                solutions.push($(this).val());
            });

            let selectedSector = $("input[name='sector']:checked").val() || "";
            if (selectedSector === "Muulla alalla" && $("#sectorOther").val()) {
                selectedSector = `Muulla alalla: ${$("#sectorOther").val()}`;
            }

            let userMessage = $("#demoMessage").val() || "";

            let additionalInfoParts = [];
            if (organization) {
                additionalInfoParts.push(`Organisaatio: ${organization}`);
            }
            if (solutions.length > 0) {
                additionalInfoParts.push(`Kiinnostavat ratkaisut: ${solutions.join(', ')}`);
            }
            if (selectedSector) {
                additionalInfoParts.push(`Toimiala: ${selectedSector}`);
            }
            if (userMessage) {
                additionalInfoParts.push(`Viesti: ${userMessage}`);
            }

            let additionalInformation = additionalInfoParts.join('\n\n');

            let code = "";
            if ($('#newsletterCheckbox').is(':checked')) {
                code = "newsletter";
            }

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                organizationName: organization,
                additionalInformation: additionalInformation,
                competitionName: "Demo",
                uri: Uris.uri,
                languageCode: language,
                code: code
            };

            getRecaptchaToken().then(function (token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#demoSendBtn").prop("disabled", false);
                    $("#demoSendBtn").css("background-color", "#28a745");
                });
            });
        } else {
            $('#demoForm')[0].reportValidity();
        }
    });

    // Show/focus other sector input when selected
    $("input[name='sector']").on("change", function () {
        if ($("#sectorOtherRadio").is(":checked")) {
            $("#sectorOther").slideDown().focus();
        } else {
            $("#sectorOther").slideUp();
        }
    });

    // Function to toggle button state based on form validity
    function toggleSendButtonState() {
        const formValid = $('#demoForm')[0].checkValidity();

        if (formValid) {
            $("#demoSendBtn").prop("disabled", false);
            $("#demoSendBtn").css("background-color", "#28a745");
        } else {
            $("#demoSendBtn").prop("disabled", true);
            $("#demoSendBtn").css({
                "background-color": "#6c757d",
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger button state change on input changes
    $('#demoForm input, #demoForm textarea').on('input change', toggleSendButtonState);

    // Initial button state check
    toggleSendButtonState();
});
